(function() {
	
	var Container = include("PIXI.Container"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Application = include("springroll.Application"),
		Tween = include("createjs.Tween");
		
	var StealthPanel = function()
	{
		Container.call(this);
		
		this.background = null;
		this.levelContainer = null;
		this.floorContainer = null;
		this.wallTopContainer = null;
		this.transition = null;
		
		this.onTransitionDone = this.onTransitionDone.bind(this);
	};
	
	var p = StealthPanel.prototype = Object.create(Container.prototype);
	
	p.setup = function()
	{
		// create a new Sprite using the texture
		this.background = new Sprite(Texture.fromImage("blank_bg"));
		this.addChild(this.background);
		
		this.floorContainer = new Container();
		this.addChild(this.floorContainer);
		
		this.levelContainer = new Container();
		this.addChild(this.levelContainer);
		
		this.wallTopContainer = new Container();
		this.addChild(this.wallTopContainer);
		
		this.transition = new Sprite(Texture.fromImage("black"));
		this.addChild(this.transition);
		this.transition.visible = false;
	};
	
	p.showTransition = function(callback)
	{
		this.transition.visible = true;
		this.transition.alpha = 0;
		Tween.get(this.transition).to({alpha:1}, 500).call(callback);
	};
	
	p.hideTransition = function(callback)
	{
		Tween.get(this.transition).to({alpha:0}, 500).call(this.onTransitionDone).call(callback);
	};
	
	p.onTransitionDone = function()
	{
		this.transition.visible = false;
	};
	
	p.teardown = function()
	{
		if(!this.floorContainer) return;
		
		this.removeChildren();
		this.floorContainer.destroy();
		this.levelContainer.destroy();
		this.wallTopContainer.destroy();
		this.background.destroy();
		this.transition.destroy();
		this.background = this.levelContainer = this.floorContainer = this.transition =
			this.wallTopContainer = null;
	};
	
	namespace('heist').StealthPanel = StealthPanel;
}());